// Personal background image as a WASHED-OUT backdrop behind the main content (REQ-THEME-003↺).
// The image is exposed as a CSS var (`--bg-image`) and drawn by a low-opacity (~10%) fixed layer
// BEHIND the app content; the data panels stay on a solid --color-surface so text is always legible
// on an AA surface. Pure DOM — the opacity/placement live in CSS.
export function applyBackground(body: HTMLElement, url: string | null): void {
  if (url) {
    body.style.setProperty("--bg-image", `url("${url}")`);
    body.classList.add("has-bg");
  } else {
    body.style.removeProperty("--bg-image");
    body.classList.remove("has-bg");
  }
}
